var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScheduleCreativeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3516 10.0859V15.0044L17.196 16.8488",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.63 20.4785C26.6421 21.565 27.6482 22.1083 27.6482 22.995C27.6482 23.8817 26.6421 24.425 24.63 25.5115L23.2598 26.2515C21.7146 27.0859 20.942 27.5031 20.5704 27.1998C19.6606 26.4569 21.078 24.5395 21.4267 23.8603C21.7801 23.1721 21.7737 22.8055 21.4267 22.1297C21.078 21.4505 19.6606 19.5332 20.5704 18.7902C20.942 18.4869 21.7146 18.9041 23.2598 19.7385L24.63 20.4785Z",
    stroke: "white",
    strokeWidth: 1.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6135 27.2353C16.1987 27.2776 15.7777 27.2993 15.3518 27.2993C8.56082 27.2993 3.05566 21.7941 3.05566 15.0032C3.05566 8.21219 8.56082 2.70703 15.3518 2.70703C22.1427 2.70703 27.6479 8.21219 27.6479 15.0032C27.6479 15.8453 27.5632 16.6678 27.402 17.4624",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleCreativeIcon);
export default __webpack_public_path__ + "static/media/Schedule-creative-icon.52642d2704282fb439f81dd61d0ff4a0.svg";
export { ForwardRef as ReactComponent };